import { render, staticRenderFns } from "./UpdateInvestorErrorNotification.vue?vue&type=template&id=8e4f7566&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports